import React from "react";
import { useSearchParams } from "react-router-dom";
import Panda from "../components/Panda";

// Renders app-store brand art with the real mascot for capture (?kind=icon | splash). Not linked from the UI.
const BrandAssets = () => {
  const [params] = useSearchParams();
  const kind = params.get("kind") || "icon";
  const scarf = "#e5356f";
  if (kind === "splash") {
    return (
      <div id="brand-splash" style={{ width: 390, height: 844, background: "#1b8bc9", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "#fff", fontFamily: "Literata, serif" }} data-testid="brand-splash">
        <Panda size={200} accessory="glasses" scarf={scarf} item="coin" />
        <p style={{ marginTop: 28, fontStyle: "italic", fontWeight: 700, fontSize: 22, color: "#d8eefb", fontFamily: "Work Sans, sans-serif" }}>Teach your child</p>
        <p style={{ margin: 0, fontSize: 56, fontWeight: 800, letterSpacing: 2, fontFamily: "Work Sans, sans-serif" }}>
          <span style={{ color: "#e5356f" }}>C</span><span style={{ color: "#f7931e" }}>r</span><span style={{ color: "#63c79a" }}>e</span><span style={{ color: "#ffffff" }}>d</span><span style={{ color: "#f3c932" }}>i</span><span style={{ color: "#d8c4f5" }}>t</span>
        </p>
      </div>
    );
  }
  return (
    <div id="brand-icon" style={{ width: 390, height: 390, background: "linear-gradient(160deg, #2a9fe0 0%, #1b8bc9 55%, #156f9f 100%)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", overflow: "hidden" }} data-testid="brand-icon">
      <div style={{ position: "absolute", width: 300, height: 300, borderRadius: "50%", background: "rgba(255,255,255,0.10)", top: -90, right: -70 }} />
      <div style={{ position: "absolute", width: 220, height: 220, borderRadius: "50%", background: "rgba(255,255,255,0.08)", bottom: -80, left: -60 }} />
      <Panda size={300} accessory="glasses" scarf={scarf} item="coin" />
    </div>
  );
};

export default BrandAssets;
